var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},[_c('p',{staticClass:"alert alert-danger"},[_vm._v("No pueden haber dos entradas con mismo nombre y apellidos ni dni.")])])
}]

export { render, staticRenderFns }